/**
 * Import Action Normalization
 *
 * Maps raw broker action strings to TransactionType enum values.
 * Used during import to normalize external data to internal format.
 */

import { TransactionType } from '../../enums/TransactionType.js';

// Re-export TransactionType and classification functions for convenience
export {
  TransactionType,
  isAcquisition,
  isDisposition,
  isOptionTransaction,
  isOptionOpen,
  isOptionClose,
  isIncomeAction,
  isDeposit,
  isWithdrawal,
  ACQUISITION_ACTIONS,
  DISPOSITION_ACTIONS,
  OPTION_ACTIONS,
  OPTION_OPEN_ACTIONS,
  OPTION_CLOSE_ACTIONS,
  INCOME_ACTIONS,
} from '../../enums/TransactionType.js';

// =============================================================================
// ACTION CONSTANTS (using enum values)
// These provide named constants for use in action maps
// =============================================================================

// Basic Buy/Sell
export const ACTION_BUY = TransactionType.Buy;
export const ACTION_SELL = TransactionType.Sell;

// Option Transactions
export const ACTION_SELL_TO_OPEN = TransactionType.SellToOpen;
export const ACTION_BUY_TO_OPEN = TransactionType.BuyToOpen;
export const ACTION_SELL_TO_CLOSE = TransactionType.SellToClose;
export const ACTION_BUY_TO_CLOSE = TransactionType.BuyToClose;
export const ACTION_OPTION_EXPIRATION = TransactionType.OptionExpiration;
export const ACTION_OPTION_ASSIGNMENT = TransactionType.OptionAssignment;
export const ACTION_OPTION_EXERCISE = TransactionType.OptionExercise;

// Income Types
export const ACTION_DIVIDEND = TransactionType.Dividend;
export const ACTION_INTEREST = TransactionType.Interest;
export const ACTION_REINVESTMENT = TransactionType.Reinvestment;
export const ACTION_FPL_INCOME = TransactionType.FplIncome;
export const ACTION_CAPITAL_GAIN_LONG = TransactionType.CapitalGainDistributionLong;
export const ACTION_CAPITAL_GAIN_SHORT = TransactionType.CapitalGainDistributionShort;

// Transfers & Wires
export const ACTION_TRANSFER_IN = TransactionType.TransferIn;
export const ACTION_TRANSFER_OUT = TransactionType.TransferOut;
export const ACTION_DEPOSIT = TransactionType.Deposit;
export const ACTION_WITHDRAWAL = TransactionType.Withdrawal;

// Sweep/Cash Management
export const ACTION_SWEEP_IN = TransactionType.SweepIn;
export const ACTION_SWEEP_OUT = TransactionType.SweepOut;

// Fees & Adjustments
export const ACTION_FEE = TransactionType.Fee;
export const ACTION_CASH_ADJUSTMENT = TransactionType.CashAdjustment;
export const ACTION_JOURNAL = TransactionType.Journal;

// Corporate Actions
export const ACTION_REDEMPTION = TransactionType.Redemption;
export const ACTION_REDEMPTION_CANCEL = TransactionType.RedemptionCancel;
export const ACTION_MERGER = TransactionType.Merger;
export const ACTION_SPLIT = TransactionType.Split;
export const ACTION_SPINOFF = TransactionType.Spinoff;

// Raw broker action strings resolve through actionResolver.ts (SYNC-20).
